<div class="d-flex flex-row align-items-center">
    <label for="subscription" class="form-label mb-0 me-3">Subscription:</label>
    <select 
        id="subscription" 
        name="subscription" 
        class="form-select form-select-sm" 
        [disabled]="!isAnySubscription"
        (change)="this.changeSubscription($event)">
        <option *ngFor="let sub of this.subscriptionItems" 
            [value]="sub.subscriptionId" 
            [disabled]="sub.isDisabled"
            [selected]="sub.isSelected">
                {{sub.subscriptionName}} ({{sub.vendor}})
                <span *ngIf="sub.isPending"> - Pending</span>
        </option>
    </select>
</div>